const dict = {
  en: {
    Madrelingua: 'Mother tongue',
    TutteSituazioniLavorative: 'In all work situations',
    SituazioniLavorativeSemplici: 'In simple work situations',
    ComunicazioneElementare: 'Only to communicate in an elementary way',

    Esperienza: 'Experience',
    AncoraInEssere: 'Still in place',
    Mese: 'Month',
    Anno: 'Year',
    DatadiInizio: 'Start Date',
    DatadiFine: 'End Date',
    TipodiContratto: 'Contract Type',
    NonSpecificato: 'Not specified',
    TempoPieno: 'Full time',
    'Part-time': 'Part time',
    Autonomo: 'Freelance',
    Contract: 'Classification, level or contract',
    Ruolo: 'Role',
    Azienda: 'Company',
    UnitàOrganizzativa: 'Business Unit',
    TipoRetribuzione: 'Unità Organizzativa',
    AnnuaLorda: 'Annual gross (RAL)',
    MensileNetta: 'Net monthly',
    RetribuzioneFissa: 'Fixed remuneration',
    RetribuzioneVar: 'Variable remuneration',
    Valuta: 'Currency',
    Benefits: 'Benefits',
    Referenze: 'Reference',
    Note: 'Notes',

    Formazione: 'Education',
    AnnodiInizio: 'Start Year',
    AnnodiFine: 'End Year',
    Durata: 'Contract Type',
    Livello: 'Level',
    SelezionaLivello: 'Select Level',
    Primaria: 'Primary',
    Secondaria: 'Secondary',
    PostSecondaria: 'Post secondary',
    Universitaria: 'University',
    PostUniversitaria: 'Post university',
    Altro: 'Other',
    NomeIstituto: 'Institute Name',
    Località: 'Locality',
    Titolo: 'Title obtained',
    Settore: 'Sector',

    NonSelezionato: 'Not specified',

    Aggiungi: 'Add',

    AllegaDocumento: 'Attach document',
  },
  it: {
    Madrelingua: 'Madrelingua',
    TutteSituazioniLavorative: 'In tutte le situazioni lavorative',
    SituazioniLavorativeSemplici: 'Nelle situazioni lavorative semplici',
    ComunicazioneElementare: 'Solo per comunicare in modo elementare',

    Esperienza: 'Esperienza',
    AncoraInEssere: 'Ancora in essere',
    Mese: 'Mese',
    Anno: 'Anno',
    DatadiInizio: 'Data di Inizio',
    DatadiFine: 'Data di Fine',
    TipodiContratto: 'Tipo di Contratto',
    NonSpecificato: 'Non specificato',
    TempoPieno: 'Dipendente a tempo pieno',
    'Part-time': 'Dipendente part-time',
    Autonomo: 'Lavoratore autonomo / Libero professionista',
    Contract: 'Inquadramento, livello o contratto',
    Ruolo: 'Ruolo',
    Azienda: 'Azienda',
    UnitàOrganizzativa: 'Unità Organizzativa',
    TipoRetribuzione: 'Tipo di retribuzione',
    AnnuaLorda: 'Annua lorda (RAL)',
    MensileNetta: 'Mensile netta',
    RetribuzioneFissa: 'Retribuzione fissa',
    RetribuzioneVar: 'Retribuzione var.',
    Valuta: 'Valuta',
    Benefits: 'Benefits',
    Referenze: 'Referenze',
    Note: 'Note',

    Formazione: 'Formazione',
    AnnodiInizio: 'Anno di Inizio',
    AnnodiFine: 'Anno di Fine',
    Durata: 'Durata (Anni)',
    Livello: 'Livello',
    SelezionaLivello: 'Seleziona il livello',
    Primaria: 'Primaria o obbligatoria',
    Secondaria: 'Secondaria superiore',
    PostSecondaria: 'Post secondaria',
    Universitaria: 'Universitaria',
    PostUniversitaria: 'Post universitaria',
    Altro: 'Altro',
    NomeIstituto: 'Nome dell Istituto',
    Località: 'Località',
    Titolo: 'Titolo ottenuto',
    Settore: 'Settore',

    NonSelezionato: 'Non selezionato',
    Aggiungi: 'Aggiungi',
    AllegaDocumento: 'Allega documento',
  },
  fr: {
    Madrelingua: 'Locuteur',
    TutteSituazioniLavorative: 'Dans toutes les situations de travail',
    SituazioniLavorativeSemplici: 'Dans des situations de travail simples',
    ComunicazioneElementare: 'Seulement pour communiquer de manière élémentaire',

    Esperienza: 'Expérience',
    AncoraInEssere: 'Toujours en place',
    Mese: 'Mois',
    Anno: 'Année',
    DatadiInizio: 'Date de début',
    DatadiFine: 'Date de fin',
    TipodiContratto: 'Type de contrat',
    NonSpecificato: 'Non spécifié',
    TempoPieno: 'Employé à temps plein',
    'Part-time': 'Employé à temps partiel',
    Autonomo: 'Indépendant',
    Contract: 'Classification, niveau ou contrat',
    Ruolo: 'Rôle',
    Azienda: 'Société',
    UnitàOrganizzativa: 'Unité d organisation',
    TipoRetribuzione: 'Type de rémunération',
    AnnuaLorda: 'Brut annuel (RAL)',
    MensileNetta: 'Net mensuel',
    RetribuzioneFissa: 'Rémunération fixe',
    RetribuzioneVar: 'Rémunération variable',
    Valuta: 'Monnaie',
    Benefits: 'Benefits',
    Referenze: 'Références',
    Note: 'Notes',

    Formazione: 'Formation',
    AnnodiInizio: 'Année de début',
    AnnodiFine: 'Année de fin',
    Durata: 'Durée (années)',
    Livello: 'Niveau',
    SelezionaLivello: 'Sélectionnez le niveau',
    Primaria: 'Primaire ou obligatoire',
    Secondaria: 'Secondaire',
    PostSecondaria: 'Poste secondaire',
    Universitaria: 'Université',
    PostUniversitaria: 'Post université',
    Altro: 'Autre',
    NomeIstituto: 'Nom de l institut',
    Località: 'Emplacement',
    Titolo: 'Titre obtenu',
    Settore: 'Secteur',

    NonSelezionato: 'Non spécifié',
    Aggiungi: 'Ajouter',
    AllegaDocumento: 'Joindre un document',
  },
};

export default dict;

